import { render, staticRenderFns } from "./Xorpay.vue?vue&type=template&id=17f9ad8a&scoped=true&"
import script from "./Xorpay.vue?vue&type=script&lang=js&"
export * from "./Xorpay.vue?vue&type=script&lang=js&"
import style0 from "./Xorpay.vue?vue&type=style&index=0&id=17f9ad8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f9ad8a",
  null
  
)

export default component.exports